import React, { createContext, useContext, useState } from 'react';
import { ProdutoCarrinho, TotemStep } from './TotemFlow';

interface TotemContextType {
  step: TotemStep;
  setStep: (step: TotemStep) => void;
  pedidoPk: string;
  setPedidoPk: (pk: string) => void;
  numeroPedido: string;
  setNumeroPedido: (n: string) => void;
  clienteNome: string;
  setClienteNome: (nome: string) => void;
  produtos: ProdutoCarrinho[];
  setProdutos: (produtos: ProdutoCarrinho[]) => void;
  tipoRetirada: string;
  setTipoRetirada: (tipo: string) => void;
  formaPagamento: any[];
  setFormaPagamento: (forma: any[]) => void;
  valorTotal: string;
  setValorTotal: (valor: string) => void;
  resetTotem: () => void;
}

const TotemContext = createContext<TotemContextType>({} as TotemContextType);

export const useTotem = () => useContext(TotemContext);

export const TotemProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [step, setStep] = useState<TotemStep>('inicio');
  const [pedidoPk, setPedidoPk] = useState('');
  const [numeroPedido, setNumeroPedido] = useState('');
  const [clienteNome, setClienteNome] = useState('');
  const [produtos, setProdutos] = useState<ProdutoCarrinho[]>([]);
  const [tipoRetirada, setTipoRetirada] = useState('');
  const [formaPagamento, setFormaPagamento] = useState<any[]>([]);
  const [valorTotal, setValorTotal] = useState('0,00');

  const resetTotem = () => {
    setStep('inicio');
    setPedidoPk('');
    setNumeroPedido('');
    setClienteNome('');
    setProdutos([]);
    setTipoRetirada('');
    setFormaPagamento([]);
    setValorTotal('0,00');
  };

  return (
    <TotemContext.Provider value={{
      step, setStep,
      pedidoPk, setPedidoPk,
      numeroPedido, setNumeroPedido,
      clienteNome, setClienteNome,
      produtos, setProdutos,
      tipoRetirada, setTipoRetirada,
      formaPagamento, setFormaPagamento,
      valorTotal, setValorTotal,
      resetTotem,
    }}>
      {children}
    </TotemContext.Provider>
  );
};

export default TotemContext;
